<template>
  <div id="app">
    <ul id="menu">
      <li>
        <a href="https://www.epa.gov/" target="_blank" rel="noopener" class="epa-logo"></a>
      </li>
      <li data-menuanchor="page1" class="active">
        <a href="#page1">Home</a>
      </li>
      <li data-menuanchor="page2">
        <a href="#page2">About</a>
      </li>
      <li data-menuanchor="page3">
        <a href="#page3">Overview</a>
      </li>
      <li data-menuanchor="page4">
        <a href="#page4">Energy</a>
      </li>
      <li data-menuanchor="page5">
        <a href="#page5">Industrial Processes</a>
      </li>
      <li data-menuanchor="page6">
        <a href="#page6">Agriculture</a>
      </li>
      <li data-menuanchor="page7">
        <a href="#page7">Waste</a>
      </li>
      <li>
        <a
          href="https://www.epa.gov/sites/production/files/2019-09/documents/epa_non-co2_greenhouse_gases_rpt-epa430r19010.pdf"
          target="_blank"
          rel="noopener"
        >Download PDF</a>
      </li>
      <li>
        <a href="https://cfpub.epa.gov/ghgdata/nonco2/" target="_blank" rel="noopener">Data Tool</a>
      </li>
    </ul>

    <full-page :options="options" id="fullpage" ref="fullpage">
      <div class="section">
        <HomeScreen />
      </div>
      <div class="section aboutSection">
        <AboutScreen />
      </div>
      <div class="section">
        <OverviewScreen />
      </div>
      <div class="section">
        <EnergyScreen />
      </div>
      <div class="section">
        <IndustrialProcessesScreen />
      </div>
      <div class="section">
        <AgricultureScreen />
      </div>
      <div class="section">
        <WasteScreen />
      </div>
    </full-page>
  </div>
</template>

<script>
// @ is an alias to /src
import HomeScreen from "@/components/Home.vue";
import AboutScreen from "@/components/About.vue";
import OverviewScreen from "@/components/Overview.vue";
import EnergyScreen from "@/components/Energy.vue";
import IndustrialProcessesScreen from "@/components/IndustrialProcesses.vue";
import AgricultureScreen from "@/components/Agriculture.vue";
import WasteScreen from "@/components/Waste.vue";

//hui added
//import Chart from "./components/Chart";
//import Button from "./components/Button";

export default {
  name: "app",
  components: {
    HomeScreen,
    AboutScreen,
    OverviewScreen,
    EnergyScreen,
    IndustrialProcessesScreen,
    AgricultureScreen,
    WasteScreen

    //highcharts: Chart,
    //btn: Button
  },
  data() {
    return {
      options: {
        licenseKey: "4FB09DFF-276B4A71-838656AB-954EC16F",
        afterLoad: this.afterLoad,
        scrollOverflow: false,
        scrollBar: true,
        menu: "#menu",
        navigation: true,
        responsiveWidth: 736,
        //responsiveHeight: 700,
        responsiveSlides: true,
        fitToSection: true,
        anchors: [
          "page1",
          "page2",
          "page3",
          "page4",
          "page5",
          "page6",
          "page7"
        ],
        sectionsColor: [],
        navigationTooltips: [
          "Home",
          "About",
          "Overview",
          "Energy",
          "Industrial Processes",
          "Agriculture",
          "Waste"
        ]
      }
    };
  },
  methods: {
    afterLoad() {
      //console.log('After load')
      //this.$refs.fullpage.api.setAllowScrolling(false);
    },
    addSection(e) {
      e.preventDefault();
      var newSectionNumber =
        document.querySelectorAll(".fp-section").length + 1;
      // creating the section div
      var section = document.createElement("div");
      section.className = "section";
      section.innerHTML = `<h3>Section ${newSectionNumber}</h3>`;
      // adding section
      document.querySelector("#fullpage").appendChild(section);
      // creating the section menu element
      var sectionMenuItem = document.createElement("li");
      sectionMenuItem.setAttribute(
        "data-menuanchor",
        "page" + newSectionNumber
      );
      sectionMenuItem.innerHTML = `<a href="#page${newSectionNumber}">Section${newSectionNumber}</a>`;
      // adding it to the sections menu
      var sectionsMenuItems = document.querySelector("#menu");
      sectionsMenuItems.appendChild(sectionMenuItem);
      // adding anchor for the section
      this.options.anchors.push(`page${newSectionNumber}`);
      // we have to call `update` manually as DOM changes won't fire updates
      // requires the use of the attribute ref="fullpage" on the
      // component element, in this case, <full-page>
      // ideally, use an ID element for that element too
      this.$refs.fullpage.build();
    },
    removeSection() {
      var sections = document
        .querySelector("#fullpage")
        .querySelectorAll(".fp-section");
      var lastSection = sections[sections.length - 1];
      // removing the last section
      lastSection.parentNode.removeChild(lastSection);
      // removing the last anchor
      this.options.anchors.pop();
      // removing the last item on the sections menu
      var sectionsMenuItems = document.querySelectorAll("#menu li");
      var lastItem = sectionsMenuItems[sectionsMenuItems.length - 1];
      lastItem.parentNode.removeChild(lastItem);
    },
    toggleNavigation() {
      this.options.navigation = !this.options.navigation;
    },
    toggleScrollbar() {
      //console.log('Changing scrollbar...')
      this.options.scrollBar = !this.options.scrollBar;
    },

    assignDialogReference(dialog) {
      this.dialog = dialog;
    },

    openMainDialog() {
      if (this.dialog) {
        this.dialog.show();
      }
    }
  },

  computed: {
    useFallback() {
      return typeof window.HTMLDialogElement !== "function";
    }
  }
};
</script>
<style>
body {
  height: 100vh;
  /*overflow-y: hidden;*/
  padding-right: 15px; /* Avoid width reflow */
  -webkit-overflow-scrolling: touch;
}

#dialog-root button[aria-label="Close this dialog window"] {
  position: absolute;
  top: 11px;
  right: 5px;
  color: #012e51;
  background-color: #fff;
  padding: 0 0.5rem;
  font-size: 1.2rem;
  font-weight: bold;
  z-index: 2;
}
#main-dialog1[aria-hidden="true"],
#main-dialog2[aria-hidden="true"],
#main-dialog3[aria-hidden="true"],
#main-dialog4[aria-hidden="true"],
#main-dialog5[aria-hidden="true"],
#main-dialog6[aria-hidden="true"],
#main-dialog7[aria-hidden="true"],
#main-dialog8[aria-hidden="true"],
#main-dialog9[aria-hidden="true"],
#main-dialog10[aria-hidden="true"],
#main-dialog11[aria-hidden="true"],
#main-dialog12[aria-hidden="true"],
#main-dialog13[aria-hidden="true"],
#main-dialog14[aria-hidden="true"],
#main-dialog15[aria-hidden="true"],
#main-dialog16[aria-hidden="true"] {
  display: none !important;
}

#dialog-root div[role="dialog"] {
  position: fixed;
  transform: translate3d(0, 0, 0);
  top: 150px;
  left: 100px;
  right: 100px;
  bottom: 100px;
  min-width: 160px;
  -webkit-box-shadow: 0px 0px 11px -1px rgba(0, 0, 0, 0.4);
  -moz-box-shadow: 0px 0px 11px -1px rgba(0, 0, 0, 0.4);
  box-shadow: 0px 0px 11px -1px rgba(0, 0, 0, 0.4);
  border-radius: 5px;
}
#dialog-root .content {
  background-color: #fff;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 30px;
}
</style>